<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/service/route'">
      <ZuiHeader/>
      <SubPageTemplate page-title="经典路线" :pid="$cid.intro.jingDianXianLu" :ext1-empty="false" :page-size="6"
                       type="article"
                       :video-mask="false" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter/>
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  mounted: function() {
			localStorage.removeItem('article_pid');
			ocalStorage.removeItem('article_pname');	
	},
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/service/route/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/service/route.vue